import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './stores'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ko'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {Company as api}  from 'api'

import 'assets/css/style.bundle.css'
// Plugins
import App from './App.vue'
// router setup
import routes from './routes/routes'
// plugin setup
Vue.use(VueRouter)

Vue.use(ElementUI, { locale })

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
})

router.beforeEach(function (to, from, next) {
  NProgress.start()
  next() // make sure to always call next()!
})

router.afterEach((to, from) => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  const $store = router.app.$store

  if (!$store.getters.isLoggedIn) {
    if (localStorage) {
      const item = localStorage.getItem('login-information')
      if (item) {
        const parse = JSON.parse(item)
        const commit = $store.commit
        commit('companyID', parse.companyID)
        commit('accountID', parse.accountID)
        commit('userType', parse.userType)
        commit('accessToken', parse.accessToken)
        commit('header', parse.header)
        window._VUE_STATE = $store.state

        api.get(parse.accountID, parse.companyID).then(({data})=>{
          window.HOSPITAL_NAME = data.companyName
          window.COMAPNY_DETAIL = data
        })
      }
    }
  }

  if (to.name === 'LoginPage' || $store.getters.isLoggedIn) {
    next()
  } else {
      next({
      name: 'LoginPage',
      params: {
        redirect: to,
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  render: h => h(App),
  router,
})



// WEBPACK FOOTER //
// ./src/main.js